function Card({ children, className = '' }) {
  return (
    <div className={`custom-card bg-white overflow-y-scroll text-black max-w-5xl w-11/12 sm:w-10/12 lg:w-9/12 h-9/12 max-h-[80vh] sm:max-h-[90vh] sm:h-auto flex flex-col items-center justify-start px-2 py-6 sm:py-10 sm:px-4 xl:p-10 rounded-md shadow-md ${className}`}>
      {children}
    </div>
  );
}

export default Card;
